module.exports = __webpack_public_path__ + "img/square-n.51d813d7.svg";